/**
 * @generated SignedSource<<68cce46e48a9286a4a01d8b0b4dc05a4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateGitHubInstallationLinkInput = {
  source?: string | null | undefined;
};
export type GithubIntegrationCreateGitHubInstallationLinkMutation$variables = {
  input?: CreateGitHubInstallationLinkInput | null | undefined;
};
export type GithubIntegrationCreateGitHubInstallationLinkMutation$data = {
  readonly createGithubInstallationLink: {
    readonly installationLink: string;
  };
};
export type GithubIntegrationCreateGitHubInstallationLinkMutation = {
  response: GithubIntegrationCreateGitHubInstallationLinkMutation$data;
  variables: GithubIntegrationCreateGitHubInstallationLinkMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateGitHubInstallationLinkPayload",
    "kind": "LinkedField",
    "name": "createGithubInstallationLink",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "installationLink",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GithubIntegrationCreateGitHubInstallationLinkMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GithubIntegrationCreateGitHubInstallationLinkMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "64f0a133e533ce79b452ac7d69e188fd",
    "id": null,
    "metadata": {},
    "name": "GithubIntegrationCreateGitHubInstallationLinkMutation",
    "operationKind": "mutation",
    "text": "mutation GithubIntegrationCreateGitHubInstallationLinkMutation(\n  $input: CreateGitHubInstallationLinkInput\n) {\n  createGithubInstallationLink(input: $input) {\n    installationLink\n  }\n}\n"
  }
};
})();

(node as any).hash = "47eafaf71c4540d9e2965e2d800d21a8";

export default node;
